import React from 'react'
import { useCoachChat } from './CoachChatContext'
import { useTranslation } from '~/hooks/useTranslation'
import CandidateListItem from './CandidateListItem'
import {
  getWaitingRoomCardClass,
  getWaitingRoomCardHeadingClass,
} from './coachDashboardStyles'

const CandidatesList = ({ candidates, embedded = false }) => {
  const { getDarkModeClasses, chatManager } = useCoachChat()
  const { t } = useTranslation('coach_chat')

  const containerClasses = embedded
    ? `${getWaitingRoomCardClass(getDarkModeClasses)} h-full`
    : `flex h-full min-h-0 flex-col overflow-hidden rounded-lg border p-4 ${getDarkModeClasses(
        'border-gray-200 bg-white',
        'border-gray-600 bg-gray-800',
      )}`

  const headingClass = embedded
    ? getWaitingRoomCardHeadingClass(getDarkModeClasses)
    : `mb-3 flex-shrink-0 text-sm font-medium ${getDarkModeClasses(
        'text-gray-900',
        'text-white',
      )}`

  return (
    <div className={containerClasses}>
      <h3 className={headingClass}>
        {t('coach_dashboard.candidates', 'Candidates')}
      </h3>
      <div className="min-h-0 flex-1 space-y-2 overflow-y-auto">
        {candidates && candidates.length > 0 ? (
          candidates.map((candidate) => (
            <CandidateListItem
              key={candidate.easyrtcid}
              candidate={candidate}
              embedded={embedded}
              chatManager={chatManager}
              getDarkModeClasses={getDarkModeClasses}
              t={t}
            />
          ))
        ) : (
          <p
            className={`py-4 text-center font-['Roboto'] text-sm ${getDarkModeClasses(
              'text-gray-500',
              'text-gray-400',
            )}`}
          >
            {t('coach_dashboard.no_candidates', 'No candidates in room')}
          </p>
        )}
      </div>
    </div>
  )
}

export default CandidatesList
